// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoAvatar_container__bPmD5","icon":"VideoAvatar_icon__2w0yc","userText":"VideoAvatar_userText__CRYN7"};